<template>
    <h1>门店</h1>
</template>